import { h } from "preact";
import "./spacer.scss";

export function Spacer() {
    return (
        <div className="component4-spacer" />
    );
}
